import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import { getMinutesFromStartOfDay } from '@helpers';
import { scrollGridToTarget } from '@tvguide/helpers';
import ChannelList from '@tvguide/components/channellist';
import Grid from './grid';

class GridView extends Component {
  constructor(props) {
    super(props);
    this.minuteInterval;

    this.state = {
      time: moment.utc().add(+this.props.isDST, 'hour'),
      isScrolling: false,
    };

    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
  }

  componentDidMount() {
    this.minuteInterval = setInterval(
      () =>
        this.setState({ time: moment.utc().add(+this.props.isDST, 'hour') }),
      60000,
    );
    const timeIndicator = document.querySelector('[data-time-indicator]');
    if (timeIndicator) {
      scrollGridToTarget(
        timeIndicator,
        null,
        this.props.hasRendered.bind(this),
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isScrolling !== this.state.isScrolling) {
      this.toggleScrolling(this.state.isScrolling);
    }

    if (
      this.props.isLoadingTvguide == false &&
      this.props.isLoadingTvguide !== prevProps.isLoadingTvguide
    ) {
      const smContainer = document.getElementById('sm-container');
      smContainer.scrollLeft = smContainer.scrollLeft - 1;
    }
  }

  componentWillUnmount() {
    clearInterval(this.minuteInterval);
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup', this.onMouseUp);
  }

  toggleScrolling(isEnable) {
    if (isEnable) {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
    } else {
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
    }
  }

  onMouseMove(event) {
    const { clientX, scrollLeft, scrollTop, clientY } = this.state;
    this._scroller.scrollLeft = scrollLeft - clientX + event.clientX;
    this._scroller.scrollTop = scrollTop - clientY + event.clientY;
  }

  onMouseUp(e) {
    this.setState({
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0,
      clientX: 0,
      clientY: 0,
    });
  }

  onMouseDown(event) {
    const { scrollLeft, scrollTop } = this._scroller;
    this.setState({
      isScrolling: true,
      scrollLeft,
      scrollTop,
      clientX: event.clientX,
      clientY: event.clientY,
    });
  }

  attachScroller(scroller) {
    this._scroller = ReactDOM.findDOMNode(scroller);
  }

  render() {
    return (
      <div className="tvg-grid__container">
        <ChannelList />
        <div
          className="tvg-grid__inner-container"
          id="sm-container"
          ref={this.attachScroller.bind(this)}
          onMouseDown={this.onMouseDown.bind(this)}
        >
          <div
            className="tvg-grid__time"
            data-time-indicator
            style={{
              left: `${getMinutesFromStartOfDay(
                this.state.time,
                moment.utc(this.props.beginDate),
                this.props.minutesPixelRatio,
              )}px`,
            }}
          />
          <Grid />
        </div>
      </div>
    );
  }
}

export default GridView;
